exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.showRightPanel {\r\n  overflow: hidden;\r\n  position: relative;\r\n  width: calc(100% - 15px);\n}\r\n", ""]);

// exports
